<template>
  <div class="personal-info-wrapper">
    <div class="info-card">
      <div class="info-header">
        <div class="avatar-section">
          <div class="avatar-wrapper">
            <img v-if="userInfo.sex === '2'" src="@/assets/girl.png" alt="头像" class="avatar-img">
            <img v-else src="@/assets/boy.png" alt="头像" class="avatar-img">
          </div>
          <div class="user-basic">
            <h2 class="user-name">{{ userInfo.username }}</h2>
            <p class="user-account">{{ userInfo.loginAccount }}</p>
          </div>
        </div>
      </div>

      <div class="info-content">
        <div class="info-section">
          <h3 class="section-title">基础信息</h3>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">代码编号</span>
              <span class="info-value">{{ userInfo.icode }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">邮箱</span>
              <span class="info-value">{{ userInfo.email }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">手机号</span>
              <span class="info-value">{{ userInfo.userPhone }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">性别</span>
              <span class="info-value">{{ userInfo.sex | formatSex }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">年龄</span>
              <span class="info-value">{{ userInfo.age }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">积分</span>
              <span class="info-value highlight">{{ userInfo.integral }}</span>
            </div>
          </div>
        </div>

        <div class="info-section">
          <h3 class="section-title">会员信息</h3>
          <div class="info-grid">
            <div class="info-item vip-item">
              <span class="info-label">用户类型</span>
              <div v-if="userInfo.teacherFlag === '1'" class="vip-badge teacher-vip">
                <i class="el-icon-medal"></i>
                <span>教师版会员</span>
              </div>
              <div v-else :class="['vip-badge', getVipClass(userInfo.userVipType)]">
                <i :class="getVipIcon(userInfo.userVipType)"></i>
                <span>{{ userInfo.userVipType | formatUserVipType }}</span>
              </div>
            </div>
            <div class="info-item">
              <span class="info-label">注册时间</span>
              <span class="info-value">{{ userInfo.createTime }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">生效时间</span>
              <span class="info-value">{{ userInfo.startDate }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">失效时间</span>
              <span class="info-value">{{ userInfo.expiryDate }}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    formatSex(sex) {
      if (sex === 1 || sex === '1') {
        return "男"
      }
      if (sex === 2 || sex === '2') {
        return "女"
      }
      return "保密"
    },
    formatUserVipType(userVipType) {
      if (userVipType === '0') {
        return "普通用户"
      }
      if (userVipType === '1') {
        return "VIP会员-终身"
      }
      if (userVipType === '2') {
        return "超级会员"
      }
      if (userVipType === '3') {
        return "体验会员"
      }
      if (userVipType === '4') {
        return "VIP会员"
      }
      if (userVipType === '5') {
        return "SVIP会员"
      }else{
        return "普通用户"
      }
    }
  },
  props: {
    userInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    getVipClass(type) {
      const classMap = {
        '0': 'normal-user',
        '1': 'lifetime-vip',
        '2': 'super-vip',
        '3': 'trial-vip',
        '4': 'vip',
        '5': 'svip'
      }
      return classMap[type] || 'normal-user'
    },
    getVipIcon(type) {
      const iconMap = {
        '0': 'el-icon-user',
        '1': 'el-icon-trophy',
        '2': 'el-icon-star-on',
        '3': 'el-icon-present',
        '4': 'el-icon-medal',
        '5': 'el-icon-s-custom'
      }
      return iconMap[type] || 'el-icon-user'
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-info-wrapper {
  padding: 0 30px;
}

.info-card {
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
}

.info-header {
  background: linear-gradient(135deg, #F0F7FF 0%, #E8F4FF 100%);
  padding: 30px;
  border-bottom: 1px solid #E8ECF0;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.avatar-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.avatar-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.user-basic {
  flex: 1;
}

.user-name {
  font-size: 24px;
  color: #303133;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.user-account {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.info-content {
  padding: 30px;
}

.info-section {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 16px;
  color: #303133;
  margin: 0 0 20px 0;
  font-weight: 500;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #F7F8FA;
  border-radius: 6px;
  transition: all 0.3s ease;

  &:hover {
    background: #EEF2F7;
    transform: translateY(-2px);
  }
}

.info-label {
  font-size: 14px;
  color: #606266;
  min-width: 90px;
  margin-right: 20px;
  font-weight: 400;
}

.info-value {
  font-size: 14px;
  color: #303133;
  flex: 1;
  word-break: break-all;

  &.highlight {
    color: #409EFF;
    font-weight: 500;
    font-size: 16px;
  }
}

.vip-tag {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #FFE9D6 0%, #FFDBC0 100%);
  color: #E6A23C;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;

  &.teacher-vip {
    background: linear-gradient(135deg, #FFE0E0 0%, #FFD0D0 100%);
    color: #F56C6C;
  }
}

// VIP徽章样式
.vip-item {
  position: relative;
  overflow: visible;
}

.vip-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  position: relative;

  i {
    font-size: 16px;
  }

  // 普通用户
  &.normal-user {
    background: #F5F7FA;
    color: #909399;
    border: 1px solid #E4E7ED;
  }

  // 体验会员
  &.trial-vip {
    background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
    color: #4CAF50;
    border: 1px solid #A5D6A7;
  }

  // VIP会员
  &.vip {
    background: linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%);
    color: #FF8F00;
    border: 1px solid #FFD54F;
    box-shadow: 0 2px 8px rgba(255, 143, 0, 0.2);
  }

  // VIP会员-终身
  &.lifetime-vip {
    background: linear-gradient(135deg, #FCE4EC 0%, #F8BBD9 100%);
    color: #C2185B;
    border: 1px solid #F48FB1;
    box-shadow: 0 2px 12px rgba(194, 24, 91, 0.25);

    &::before {
      content: '☆';
      position: absolute;
      right: -8px;
      top: -8px;
      font-size: 16px;
      color: #FFD700;
      text-shadow: 0 0 4px rgba(255, 215, 0, 0.6);
    }
  }

  // 超级会员
  &.super-vip {
    background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
    color: #1565C0;
    border: 1px solid #64B5F6;
    box-shadow: 0 2px 10px rgba(21, 101, 192, 0.2);
  }

  // SVIP会员
  &.svip {
    background: linear-gradient(135deg, #2C2C2C 0%, #1A1A1A 100%);
    color: #FFD700;
    border: 2px solid #FFD700;
    box-shadow: 0 4px 16px rgba(255, 215, 0, 0.3);
    text-shadow: 0 0 8px rgba(255, 215, 0, 0.4);

    i {
      color: #FFD700;
    }

    &::before {
      content: '★';
      position: absolute;
      right: -10px;
      top: -10px;
      font-size: 18px;
      color: #FFD700;
      text-shadow: 0 0 6px rgba(255, 215, 0, 0.8);
      animation: sparkle 1.5s ease-in-out infinite;
    }
  }

  // 教师版会员
  &.teacher-vip {
    background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
    color: #E65100;
    border: 1px solid #FFCC80;
    box-shadow: 0 2px 12px rgba(230, 81, 0, 0.2);

    &::before {
      content: '♪';
      position: absolute;
      right: -8px;
      top: -8px;
      font-size: 14px;
      color: #E65100;
    }
  }
}

@keyframes sparkle {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.2) rotate(15deg);
    opacity: 0.8;
  }
}

@media (max-width: 1200px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
